import { forwardRef, useId, useState } from 'react';
import { Field, Checkbox as GardenCheckbox } from '@zendeskgarden/react-forms';
import type { FormCheckboxProps } from './interfaces';

export const Checkbox = forwardRef<HTMLInputElement, FormCheckboxProps>(
  (
    {
      id,
      name,
      label,
      hint,
      message,
      validation,
      error,
      className,
      wrapperClassName,
      onCheckedChange,
      onChange,
      onBlur,
      checked,
      defaultChecked,
      ...rest
    },
    ref
  ) => {
    const uid = useId();
    const checkboxId = id ?? `chk-${uid}`;

    const isControlled = checked !== undefined;
    const [internalChecked, setInternalChecked] = useState<boolean>(!!defaultChecked);
    const currentChecked = isControlled ? checked : internalChecked;

    const finalMessage = error ?? message;
    const finalValidation = error ? 'error' : validation;

    const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
      const next = e.target.checked;

      if (!isControlled) {
        setInternalChecked(next);
      }

      onChange?.(e);
      onCheckedChange?.(next);
    };

    return (
      <Field className={wrapperClassName}>
        <GardenCheckbox
          id={checkboxId}
          name={name}
          ref={ref}
          className={className}
          onChange={handleChange}
          onBlur={onBlur}
          checked={currentChecked}
          {...(!isControlled ? { defaultChecked } : {})}
          {...rest}
        >
          {label && <Field.Label htmlFor={checkboxId}>{label}</Field.Label>}
        </GardenCheckbox>

        {hint && <Field.Hint>{hint}</Field.Hint>}

        {finalMessage && (
          <Field.Message validation={finalValidation}>{finalMessage}</Field.Message>
        )}
      </Field>
    );
  }
);

Checkbox.displayName = 'Checkbox';
export default Checkbox;
